import { handleErrors, parseAsJson } from '../../utils/requestHelpers';
import fetch from '../../utils/fetchService';
import Config from '../../config';
import { QueryKeys, useCustomQuery } from './index';
import getCookie from '../../utils/getCookie';

export type SessionStatus = {
  inactivity?: number | null
  session?: number | null
};
export const useSessionStatus = ({ refetchInterval }: { refetchInterval: number }) =>
  useCustomQuery<SessionStatus>(
    [QueryKeys.session.SessionStatus],
    {
      customFetch: async () => {
        const validToken = getCookie('validToken');
        const validSessionToken = getCookie('validSessionToken');
        if (!(validToken && validSessionToken)) {
          return { inactivity: null, session: null };
        } else {
          const sessionData = await fetch(
            Config.endpoints.GET_SESSION_STATUS,
            { method: 'GET' },
            true
          )
            .then(handleErrors({ errorMessage: 'Failed to get session status' }))
            .then(parseAsJson);

          document.cookie = 'validSessionToken=true; path=/';

          return {
            inactivity: sessionData.inactivity,
            session: sessionData.session,
          };
        }
      },
      defaultData: { inactivity: null, session: null },
      showErrorToastr: false,
      onError: () => null,
      refetchInterval,
    }
  );
